import AppLayout from "../../../../shared/components/AppLayout";
import Button from "../../../../shared/components/Button";
import { siteTexts } from "../../../../shared/i18n/siteTexts";

export default function PaymentSuccessPage() {
  const t = siteTexts.paymentSuccess;
  return (
    <AppLayout>
      <section className="empty-state">
        <h1>{t.title}</h1>
        <p>{t.description}</p>
        <div style={{ display: "inline-flex", gap: 10, flexWrap: "wrap" }}>
          <Button href="#/perfil" variant="primary">
            {t.viewRegistrations}
          </Button>
          <Button href="#/desafios" variant="pill">
            {t.backToChallenges}
          </Button>
        </div>
      </section>
    </AppLayout>
  );
}
